// extracted by mini-css-extract-plugin
module.exports = {"main":"list_main__u9YR6","atv":"list_atv__O258j","name":"list_name__7uQH6","nameDiv":"list_nameDiv__KtkFN","loopRun":"list_loopRun__PYKzQ","tag":"list_tag__EatXJ"};